<template>
  <div id="app">
    <router-view />
    <div v-show="showService" style="position: fixed;bottom: 20px;right: 20px;z-index: 999;">
      <b-button @click="contactUs" variant="success" size="lg" class="rounded-circle shadow-lg"
        style="width: 56px;height: 56px;padding: 0;" title="Contact Us">
        <b-icon icon="telegram"></b-icon>
      </b-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showService: false
    }
  },
  methods: {
    handleScroll() {
      const navbar = this.$refs.navbar && this.$refs.navbar.$el;
      if (navbar) {
        const rect = navbar.getBoundingClientRect();
        this.showService = rect.bottom <= 0;
      } else {
        this.showService = window.scrollY > 85.5;
      }
    },
    contactUs() {
      this.$ContactToUs()
    },
    navTo(val) {
      this.$router.push('/collections/' + val)
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
    this.handleScroll();
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  }
}
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
